import * as React from "react";

import { Ul } from "./List.styles";

export interface ListProps {
    inline?: boolean;
    bullet?: boolean;
    dash?: boolean;
    applyListStyle?: boolean;
    children: React.ReactNode;
}

export function List(props: ListProps): JSX.Element {
    if (props.inline) {
        return <span>{props.children}</span>;
    }
    if (props.bullet) {
        const Tag = props.applyListStyle ? Ul : "ul";
        return <Tag>{props.children}</Tag>;
    }
    if (props.dash) {
        const Tag = props.applyListStyle ? Ul : "ul";
        return <Tag>{props.children}</Tag>;
    }
    return <div>{props.children}</div>;
}
